import * as React from 'react';
var TrilogyContext = React.createContext({
    styled: false,
    setStyled: function () { return undefined; },
});
var useTrilogyContext = function () {
    var context = React.useContext(TrilogyContext);
    if (context === undefined) {
        throw new Error('useTrilogyContext must be used within a TrilogyProvider');
    }
    return context;
};
export { TrilogyContext, useTrilogyContext };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9jb250ZXh0L2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQTtBQVM5QixJQUFNLGNBQWMsR0FBRyxLQUFLLENBQUMsYUFBYSxDQUFrQjtJQUMxRCxNQUFNLEVBQUUsS0FBSztJQUNiLFNBQVMsRUFBRSxjQUFNLE9BQUEsU0FBUyxFQUFULENBQVM7Q0FDM0IsQ0FBQyxDQUFBO0FBRUYsSUFBTSxpQkFBaUIsR0FBRztJQUN4QixJQUFNLE9BQU8sR0FBRyxLQUFLLENBQUMsVUFBVSxDQUFDLGNBQWMsQ0FBQyxDQUFBO0lBQ2hELElBQUksT0FBTyxLQUFLLFNBQVMsRUFBRTtRQUN6QixNQUFNLElBQUksS0FBSyxDQUFDLHlEQUF5RCxDQUFDLENBQUE7S0FDM0U7SUFDRCxPQUFPLE9BQU8sQ0FBQTtBQUNoQixDQUFDLENBQUE7QUFFRCxPQUFPLEVBQUUsY0FBYyxFQUFFLGlCQUFpQixFQUFFLENBQUEifQ==